import { useDispatch } from "react-redux";
import { AppDispatch } from "../interfaces/common";

export const useAppDispatch = () => useDispatch<AppDispatch>();
